import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import { RxCaretDown, RxCross1, RxHamburgerMenu } from 'react-icons/rx'
import FormattedMessage from '../FormattedMessage/FormattedMessage'
import { userActions } from '../../redux/actions'
import { currentUser } from '../../redux/reducers/user.reducers'
import AnnouncementHeader from './AnnouncementHeader'
import AMDSvgLogo from '../Logo/AMDSvgLogo'

import './HeaderV2.scss'

const HeaderV2 = props => {
  const {
    user,
    validSession,
    history,
    location: { pathname },
    logout,
  } = props
  const [menu, setMenu] = useState(false)
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false)
  const languageMenuRef = useRef(null)

  const [mainNav] = useState([
    { href: '/faq', name: 'FAQ', key: 'faq' },
    { href: '/support', name: 'Support', key: 'support' },
    { href: '/terms', name: 'Terms', key: 'terms' },
  ])
  const [authNav] = useState([
    { href: '/claim-reward', name: 'Claim Reward', key: 'claimReward' },
    { href: '/my-rewards', name: 'My Rewards', key: 'myRewards' },
    { href: '/my-account', name: 'My Account', key: 'myAccount' },
  ])
  const [languages] = useState([
    { name: 'English', key: 'en' },
    { name: 'Français', key: 'fr' },
    { name: 'Deutsch', key: 'de' },
    { name: 'Español', key: 'es' },
    { name: 'Italiano', key: 'it' },
    { name: '日本語', key: 'ja' },
    { name: '한국어', key: 'ko' },
    { name: 'Polski', key: 'pl' },
    { name: 'Português', key: 'pt' },
    { name: 'ROMÂNĂ', key: 'ro' },
    { name: 'Русский', key: 'ru' },
    { name: 'Türkçe', key: 'tr' },
    { name: '繁體中文', key: 'zh' },
  ])

  const changeInternationalization = (value, e) => {
    if (e) {
      e.preventDefault()
    }
    if (document) {
      document.cookie = `locale=${value};path=/;`
      window.location.reload()
    }
  }

  const toggleMenu = () => {
    setMenu(prev => !prev)
  }

  const toggleLanguageMenu = e => {
    e.preventDefault()
    setLanguageMenuOpen(prev => !prev)
  }

  useEffect(() => {
    if (!languageMenuOpen) return undefined

    const handleOutsideClick = e => {
      if (languageMenuRef.current && !languageMenuRef.current.contains(e.target)) {
        setLanguageMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [languageMenuOpen])

  const handleLogout = () => {
    logout()
    history.push('/login')
  }

  const handleLanguageKeyDown = (e, languageKey) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      changeInternationalization(languageKey)
    }
  }

  if (pathname === '/oauth/steam' || pathname === '/epic-redirect') {
    return null
  }

  return (
    <div className={`amd-page-header ${menu ? 'menu-open' : ''}`}>
      {/* Skip link for keyboard users to bypass navigation */}
      <a href="#main-content" className="sr-only sr-only-focusable">
        Skip to main content
      </a>

      <header className="container-fluid p-0" role="banner">
        <nav
          className="navbar navbar-expand-lg navbar-dark bg-dark navbar-container"
          aria-label="Main navigation"
        >
          <div className="container-fluid">
            <button
              className="navbar-toggler"
              type="button"
              aria-label="Toggle navigation"
              aria-expanded={menu ? 'true' : 'false'}
              aria-controls="main-navigation"
              onClick={() => toggleMenu()}
            >
              {!menu ? (
                <RxHamburgerMenu className="navbar-toggler-icon" aria-hidden="true" />
              ) : (
                <RxCross1 className="navbar-toggler-icon" aria-hidden="true" />
              )}
            </button>
            <div className="navbar-toggler-menu">
              <div className="navbar-brand">
                <a
                  href="https://www.amd.com/en.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="AMD website (opens in a new window)"
                >
                  <AMDSvgLogo className="navbar-brand-image" alt="AMD Logo" />
                </a>
                <NavLink to="/" aria-label="AMD Rewards Homepage">
                  <span className="navbar-brand-text">Rewards</span>
                </NavLink>
              </div>
            </div>
          </div>
        </nav>
        <nav
          className="navbar navbar-expand-lg navbar-dark second-level-nav navbar-container"
          aria-label="Secondary navigation"
        >
          <div className="container-fluid">
            <div className={`collapse navbar-collapse ${menu ? 'show' : ''}`} id="main-navigation">
              <ul className="navbar-nav">
                {!pathname.toUpperCase().includes('AMD50') &&
                  mainNav.map(navItem => (
                    <li className="nav-item" key={navItem.key}>
                      <NavLink
                        className="nav-link"
                        to={navItem.href}
                        activeClassName="active"
                        onClick={() => toggleMenu()}
                      >
                        <span>
                          <FormattedMessage id={`global.pageTitles.${navItem.key}`} />
                        </span>
                      </NavLink>
                    </li>
                  ))}
                {!validSession && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/register"
                      activeClassName="active"
                      onClick={() => toggleMenu()}
                    >
                      <span>
                        <FormattedMessage id="global.pageTitles.register" />
                      </span>
                    </NavLink>
                  </li>
                )}
                {!validSession && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/login"
                      activeClassName="active"
                      onClick={() => toggleMenu()}
                    >
                      <span>
                        <FormattedMessage id="global.pageTitles.login" />
                      </span>
                    </NavLink>
                  </li>
                )}
                <li className="nav-item dropdown" ref={languageMenuRef}>
                  <a
                    href="#language-menu"
                    className="nav-link"
                    id="languageSelector"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded={languageMenuOpen ? 'true' : 'false'}
                    onClick={toggleLanguageMenu}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        toggleLanguageMenu(e)
                      }
                    }}
                  >
                    <span>
                      <FormattedMessage id="global.pageTitles.language" />
                      <RxCaretDown className="nav-link-icon" aria-hidden="true" />
                    </span>
                  </a>
                  <div
                    className={`dropdown-menu dropdown-menu-right ${
                      languageMenuOpen ? 'show' : ''
                    }`}
                    aria-labelledby="languageSelector"
                  >
                    {languages.map(language => (
                      <button
                        key={language.key}
                        type="button"
                        className="dropdown-item"
                        onClick={e => changeInternationalization(language.key, e)}
                        onKeyDown={e => handleLanguageKeyDown(e, language.key)}
                        tabIndex="0"
                        aria-label={`Change language to ${language.name}`}
                      >
                        {language.name}
                      </button>
                    ))}
                  </div>
                </li>
              </ul>
              {validSession && (
                <div className="d-lg-none amd-mobile-auth-header">
                  <ul className="navbar-nav">
                    {authNav.map(navItem => (
                      <li className="nav-item" key={navItem.key}>
                        <NavLink
                          className="nav-link"
                          to={navItem.href}
                          activeClassName="active"
                          onClick={() => toggleMenu()}
                        >
                          <span>
                            <FormattedMessage id={`global.pageTitles.${navItem.key}`} />
                          </span>
                        </NavLink>
                      </li>
                    ))}
                    <li className="nav-item">
                      <button
                        type="button"
                        className="nav-link"
                        onClick={() => {
                          toggleMenu()
                          handleLogout()
                        }}
                        aria-label="Log out of your account"
                      >
                        <span>
                          <FormattedMessage id="global.pageTitles.logOut" />
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </nav>
      </header>
      {validSession && (
        <div
          className="amd-auth-header navbar navbar-expand-lg navbar-auth d-none d-lg-block"
          aria-label="User navigation"
        >
          <div className="container-fluid navbar-container">
            <div>
              <div className="welcome-message">
                <FormattedMessage
                  id="page.myAccountPage.title.heroTitle"
                  values={{ FirstName: user.firstname }}
                />
              </div>
            </div>
            <div className="navbar-collapse">
              <ul className="navbar-nav ml-auto">
                {authNav.map(navItem => (
                  <li className="nav-item" key={navItem.key}>
                    <NavLink className="nav-link" to={navItem.href} activeClassName="active">
                      <span>
                        <FormattedMessage id={`global.pageTitles.${navItem.key}`} />
                      </span>
                    </NavLink>
                  </li>
                ))}
                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link"
                    onClick={handleLogout}
                    aria-label="Log out of your account"
                  >
                    <span>
                      <FormattedMessage id="global.pageTitles.logOut" />
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      <AnnouncementHeader />

      {/* Main content area ID for skip link */}
      <main id="main-content" tabIndex="-1">
        {/* Your content will be rendered here */}
      </main>
    </div>
  )
}

const mapStateToProps = state => ({
  user: currentUser(state),
  validSession: state.userReducers.validSession,
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(userActions.logout()),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderV2))
